import Link from "next/link";
import React, { useState } from "react";
import { Transition } from "@headlessui/react";
import Typography from "../../common/Typography/Typography";
import Button from "../../common/Buttons/Button/Button";
import Icon from "../../common/Icon/Icon";
import iconPathRegistry from "../../common/Icon/config/iconPathRegistry";

import styles from "./SubNav.module.css";

interface Props {
    items: Array<{ label: string; href: string; icon?: keyof typeof iconPathRegistry }>;
}

const SubNav = ({ items }: Props) => {
    const [open, setOpen] = useState(false);

    return (
        <nav className="sticky top-2 z-stickyNav">
            <ul className={styles.nav}>
                <li className={`lg:hidden ${styles.navListItem}`}>
                    <Button
                        icon="chevron_down"
                        aria-expanded={open ? "true" : "false"}
                        onClick={() => setOpen((prev) => !prev)}
                        variant="none"
                        className="type-small-caps flex flex-row gap-0.75 items-center"
                        size="large"
                    >
                        Jump To
                    </Button>
                    <Transition
                        show={open}
                        enter="transition-opacity transition-transform"
                        enterFrom="opacity-0 translate-y-[-1rem]"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition-opacity transiton-transform"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-[-1rem]"
                    >
                        <ul className={styles.dropdown}>
                            {items.map((item) => (
                                <li key={item.label} className={styles.dropdownListItem}>
                                    <Link href={item.href} className={styles.dropdownListItem} onClick={() => setOpen(false)}>
                                        {item.icon ? <Icon icon={item.icon} className="text-pine-500" width={17.5} /> : null}
                                        <Typography variant="meta" color="midnight">
                                            {item.label}
                                        </Typography>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </Transition>
                </li>
                {items.map((item) => (
                    <li key={item.label} className={`hidden lg:flex flex-row items-center ${styles.navListItem}`}>
                        <Link href={item.href} className="flex gap-0.75">
                            {item.icon ? <Icon icon={item.icon} className="text-pine-500" width={17.5} /> : null}
                            <Typography variant="meta" color="midnight">
                                {item.label}
                            </Typography>
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default SubNav;
